export const type = {
    basic: "기초",
    major: "전공",
    doubleMajor: "복수전공",
    minor: "부전공",
    advancedMajor: "심화전공",
    interdisciplinaryMajor: "자유융합전공",
    research: "연구",
    general: "교양",
    basicRequired: "기초필수",
    basicElective: "기초선택",
    majorRequired: "전공필수",
    majorElective: "전공선택",
    generalRequired: "교양필수",
    humanitiesSocial: "인문사회선택",
    humanities: "인문사회선택",
    thesisStudy: "졸업연구",
    individualStudy: "개별연구",
    otherElective: "자유선택",
    unclassified: "미분류",
    etc: "기타",
    basicRequiredShort: "기필",
    basicElectiveShort: "기선",
    majorRequiredShort: "전필",
    majorElectiveShort: "전선",
    humanitiesSocialElectiveShort: "인선",
    mandatoryGeneralCourseShort: "교필",
    otherElectiveShort: "자선",
    generalRequiredShort: "공통",
    electiveGraduateShort: "석박",
    etcShort: "기타",
    totalCredit: "학점",
    totalAu: "AU",
}
